'use client';

import { useRouter } from '@bprogress/next/app';
import { useSelector } from '@xstate/store/react';

import {
  cartActions,
  selectCountProductInCart,
  storeProduct
} from '@/fo/store/product';
import {
  UiProductTileMedium,
  mapProductTileMedium
} from '@/fo/ui/product/tile/medium';
import { MappedProduct } from '@/fo/util/map-product-data';

export interface FeatureProductTileMediumProps {
  data: MappedProduct;
}

export function FeatureProductTileMedium({
  data
}: FeatureProductTileMediumProps) {
  const router = useRouter();

  const cartCount = useSelector(
    storeProduct,
    selectCountProductInCart(data?.sku)
  );

  const isInCart = cartCount > 0;

  const onCartClick = () => {
    if (isInCart) {
      router.push('/cart');
    } else {
      cartActions.addProductsToCart([
        {
          sku: data.sku,
          quantity: 1,
          product: data
        }
      ]);
    }
  };

  return (
    <UiProductTileMedium
      type="buy"
      onAddToCart={onCartClick}
      isInCart={isInCart}
      product={mapProductTileMedium(data)}
    />
  );
}
